import _ from 'lodash';
import clsx from 'clsx';
import { FormControl, RadioGroup, FormControlLabel, Radio, makeStyles } from '@material-ui/core';

export const useChartFormStyles = makeStyles((theme) => ({
    formControl: {
        padding: 0,
        margin: 0,
        display: 'flex',
    },
    label: {
        fontSize: theme.typography.pxToRem(14),
    },
    radioGroup: {
        justifyContent: 'flex-end',
    },
    radio: {
        padding: '0 0 0 16px',
    },
    fadeOnHoverTrigger: {
        '&:hover $fadeOnHover': {
            opacity: 1,
        },
    },
    fadeOnHover: {
        transitionProperty: 'opacity',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'ease',
        opacity: 0,
    },
}));

export default function ChartTypeForm({ value, onChangeType, className, selections }) {
    const classes = useChartFormStyles();
    return (
        <FormControl className={classes.formControl} component="fieldset">
            <RadioGroup
                className={clsx(classes.radioGroup, className)}
                row
                aria-label="type-of-chart"
                name="type-of-chart"
                value={value}
                onChange={(ev) => {
                    onChangeType(ev.target.value);
                }}
            >
                {selections.map((sel) => (
                    <FormControlLabel
                        className={classes.formControlLabel}
                        key={sel.value}
                        value={sel.value}
                        control={<Radio className={classes.radio} />}
                        label={sel.label}
                        classes={_.pick(classes, 'label')}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
}
